export const fi = {
  singleFile: 'yksi kerrallaan',
  title: 'Lisää liite',
  generalInfo: 'Painamalla tai raahaamalla se tähän',
  restrictionsInfo:
    '(Tiedoston maksimikoko: 10 MB. Huom! Pankkitoimintojen suojaus saattaa estää liitteiden lataamisen. Suojaus tulee poistaa käytöstä ennen liitteiden lataamista. Sallitut tiedostoformaatit: PDF, JPEG/JPG, PNG, DOC/DOCX PPT/PPTX ja XLS/XLSX)',
  loading: 'Ladataan...',
  error: {
    FileTooBig: 'Tiedosto on liian suuri',
    InvalidExtension: (ext: string): string =>
      `Tiedostopääte ${ext} ei ole sallittu`,
    InvalidMimeType: 'Tiedostotyyppi ei vastaa tiedostopäätettä',
    MissingExtension: 'Tiedostopääte puuttuu',
    Unknown: 'Lataus ei onnistu',
    nonEmptyArray: 'Liite puuttuu!',
    PublishFailure: 'Liitteen yhdistäminen hakemukseen ei onnistu!'
  }
}

export const sv = {
  singleFile: '[TODO]',
  title: 'Bifoga bilaga',
  generalInfo:
    'Genom att klicka detta område eller genoma att dra och släppa filen här',
  restrictionsInfo:
    '(Filens maximistorlek: 10 MB. Obs! Bankskydd kan förhindra infogning av bilagor. Inaktivera bankskyddet innan du fogar in bilagorna. Tillåtna filformat: PDF, JPEG/JPG, PNG, DOC/DOCX, PPT/PPTX och XLS/XLSX)',
  loading: 'Laddar...',
  error: {
    FileTooBig: 'Filen är för stor',
    InvalidExtension: (ext: string): string =>
      `Filtillägget ${ext} är inte tillåtet`,
    InvalidMimeType: 'Filformatet motsvarar inte filtillägget',
    MissingExtension: 'Filtillägget saknas',
    Unknown: 'Uppladdningen misslyckades',
    nonEmptyArray: 'Bilaga fattas!',
    PublishFailure: 'Det lyckas inte att foga bilagan till ansökan!'
  }
}

export const en = {
  singleFile: 'One at a time',
  title: 'Upload file',
  generalInfo: 'By clicking this area or dragging it here',
  restrictionsInfo:
    '(Max file size: 10 MB. Please Note! Banking Protection may prevent the uploading of attachments. You must disable the protection before uploading attachments. Supported formats: PDF, JPEG/JPG, PNG, DOC/DOCX, PPT/PPTX, and XLS/XLSX)',
  loading: 'Uploading...',
  error: {
    FileTooBig: 'File too big',
    InvalidExtension: (ext: string): string =>
      `File extension ${ext} not allowed`,
    InvalidMimeType: 'File format does not match file extension',
    MissingExtension: 'File extension missing',
    Unknown: 'Upload failed',
    nonEmptyArray: 'Missing attachment!',
    PublishFailure: 'The file cannot be attached to the application!'
  }
}

export const getLocalized = (lang: 'fi' | 'en' | 'sv') => {
  switch (lang) {
    case 'en':
      return en
    case 'sv':
      return sv
    case 'fi':
      return fi
    default:
      const _: never = lang
      return _
  }
}
